// QR customer-facing pages only (namespace: "qr"). Supports en, ar, fr, es.
const qr_ar = {
  add: "إضافة",
  additional_info: "معلومات إضافية",
  all: "الكل",
  amount: "المبلغ",
  basket: "السلة",
  basket_empty: "سلتك فارغة!",
  calories: "السعرات الحرارية",
  cancel: "إلغاء",
  cart: "السلة",
  change_mode: "تغيير الوضع",
  customer_name: "اسم العميل",
  done: "تم",
  failed_to_load_order_history: "فشل تحميل سجل الطلبات",
  failed_to_load_products: "فشل تحميل المنتجات",
  home: "الرئيسية",
  how_would_you_like_to_order: "كيف تود الطلب؟",
  insufficient_quantity: "كمية غير كافية",
  items: "العناصر",
  menu: "القائمة",
  no: "لا",
  no_menu_data_found: "لم يتم العثور على بيانات القائمة",
  options: "الخيارات",
  order_confirmed: "تم تأكيد الطلب",
  order_id: "رقم الطلب",
  order_placed_successfully: "تم تقديم طلبك بنجاح!",
  order_with_ai: "الطلب بالذكاء الاصطناعي",
  order_yourself: "اطلب بنفسك",
  out_of_stock: "نفذ من المخزون",
  place_new_order: "تقديم طلب جديد",
  place_order: "تقديم الطلب",
  please_scan_valid_qr_code_or_try_again_later:
    "يرجى مسح رمز QR صالح أو المحاولة مرة أخرى لاحقًا.",
  search_product_name_here: "ابحث عن اسم المنتج هنا",
  select_language: "اختر اللغة",
  select_options: "تحديد الخيارات",
  selected_item: "العنصر المختار",
  skip: "تخطي",
  something_went_wrong: "حدث خطأ ما",
  status: "الحالة",
  subtotal: "المجموع الفرعي",
  successfully_added: "تمت الإضافة بنجاح",
  taxes: "الضرائب",
  total: "الإجمالي",
  touch_screen: "شاشة لمس",
  validate_customer_name_required: "حقل اسم العميل مطلوب.",
  validate_vehicle_color_required: "حقل لون المركبة مطلوب.",
  validate_vehicle_number_required: "حقل رقم المركبة مطلوب.",
  vehicle_color: "لون المركبة",
  vehicle_number: "رقم المركبة",
  view_details: "عرض التفاصيل",
  voice_assistant: "المساعد الصوتي",
  voice_connection_error: "خطأ في الاتصال الصوتي. يرجى المحاولة مرة أخرى.",
  voice_session_inactive:
    "تم إيقاف المساعد الصوتي بعد فترة من السكون. اضغط على الميكروفون للبدء من جديد.",
  voice_session_time_limit:
    "وصل المساعد الصوتي إلى الحد الزمني. اضغط على الميكروفون للبدء من جديد.",
  warning_empty_basket: "هل أنت متأكد من رغبتك في حذف هذه المنتجات من السلة؟",
  welcome_to: "مرحبًا بكم في",
  yes: "نعم",
  your_order: "طلبك",

  // Voice assistant UI (options modal + floating button status) and footer.
  available_options: "خيارات متاحة",
  voice_options_instruction: "قل الخيارات التي تريد أو قل «لا» للتخطي",
  voice_initializing: "جارٍ التهيئة…",
  voice_tap_to_start: "اضغط للبدء",
  voice_listening: "يستمع… (اضغط للإيقاف المؤقت)",
  voice_speaking: "يتحدث… (اضغط للإيقاف المؤقت)",
  voice_added_to_cart: "أُضيف إلى السلة",
  voice_removed: "تمت الإزالة",
  voice_order_placed: "تم تقديم الطلب!",
  voice_active: "نشط (اضغط للإيقاف المؤقت)",
  powered_by: "مشغل بواسطة",
  voice_product_not_found:
    "عذرًا، لم أجد «{{product}}» في قائمتنا.",
  voice_product_out_of_stock: "عذرًا، {{product}} غير متوفر حاليًا.",
  voice_options_prompt:
    "هل ترغب في إضافة خيارات إلى {{product}}؟ المتاح: {{options}}. قل «لا» للتخطي، أو اذكر الخيارات التي تريدها.",
  voice_stock_limited:
    "عذرًا، المتوفر في المخزون هو {{available}} فقط من {{product}}.",
  voice_added_quantity_to_cart:
    "تمت إضافة {{quantity}} من {{product}}{{options}} إلى سلتك بنجاح.",
  voice_item_not_in_cart: "«{{product}}» غير موجود في سلتك.",
  voice_removed_quantity:
    "تمت إزالة {{quantity}} من {{product}} من سلتك.",
  voice_cart_contents: "تحتوي سلتك على: {{items}}.",
  voice_with_options: " مع {{options}}",
  voice_cart_empty_submit:
    "سلتك فارغة. يرجى إضافة منتجات قبل تقديم الطلب.",
  voice_failed_to_place_order: "فشل تقديم الطلب. يرجى المحاولة مرة أخرى.",
  voice_order_error:
    "حدث خطأ أثناء تقديم طلبك. يرجى المحاولة مرة أخرى.",
  our_store: "متجرنا",
  currency_riyals: "ريال سعودي",
  voice_order_success:
    "تم تقديم طلبك بنجاح! رقم الطلب: {{orderId}}. شكرًا لطلبك معنا!",
};

export default qr_ar;
